/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Priceunknown1Inputs */

const en_priceunknown1 = /** @type {(inputs: Priceunknown1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Price unknown`)
};

const de_priceunknown1 = /** @type {(inputs: Priceunknown1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Preis unbekannt`)
};

/**
* | output |
* | --- |
* | "Price unknown" |
*
* @param {Priceunknown1Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const priceunknown1 = /** @type {((inputs?: Priceunknown1Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Priceunknown1Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_priceunknown1(inputs)
	return de_priceunknown1(inputs)
});
export { priceunknown1 as "priceUnknown" }